import { defineMessages } from 'react-intl';

export const messages: {
	resultLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	committed: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	resultLabel: {
		id: 'search-commit-result.label',
		defaultMessage: 'Commit',
		description:
			'Badge label shown on a commit search result card to identify the result type as a code commit.',
	},
	committed: {
		id: 'search-commit-result.committed',
		defaultMessage: 'Committed {formattedDate}',
		description: 'This shows the timestamp of when the commit was made.',
	},
});
